import { ITimeRule } from '@sparelabs/api-client'
import { IListModelQueryParamValues, IModelJsonValues } from '@sparelabs/http-client-utils'

export enum AppointmentTypeStatus {
  Active = 'active',
  Archived = 'archived',
}

// To keep things consistent with time rules in launch, we work with a very similar structure and transform it to nylas format.
// Limits on Nylas' side forces us to store an associated timezone and overrides must only be exclusions.
export interface IAppointmentAvailability {
  timezone: string
  rules: ITimeRule[]
  overrides: Array<{
    date?: string
    /**
     * Must have EITHER date OR unavailableRanges, NOT both:
     * 1. date only: Entire day is unavailable (Nylas exdate)
     * 2. unavailableRanges only: Specific time spans (can cross day boundaries)
     *
     * Invalid configurations (will be ignored):
     * - Both date and unavailableRanges present
     * - Neither date nor unavailableRanges present
     *
     * unavailableRanges uses full Unix timestamps (e.g., 1710356400 for March 13, 2024 12:00 PM PST)
     */
    unavailableRanges?: Array<{ startTs: number; endTs: number }>
  }>
}

export enum AppointmentTypeTheme {
  Blue = 'blue',
  Green = 'green',
  Red = 'red',
  Yellow = 'yellow',
  Purple = 'purple',
  CoolGray = 'coolGray',
  Gray = 'gray',
}

export interface IAppointmentTypeResponse extends IModelJsonValues {
  // native properties
  key: string
  nylasConfigId: string
  adminIds: string[]
  caseTypeId: string
  formId: string
  status: AppointmentTypeStatus
  theme: AppointmentTypeTheme
  // properties from nylas
  title: string
  description: string
  duration: number
  availability: IAppointmentAvailability
  location: string
  emailsDisabled: boolean
}

export interface IListAppointmentTypeQueryParams extends IListModelQueryParamValues {
  caseTypeId?: string
  status?: AppointmentTypeStatus
}

export interface IAppointmentTypePostBody {
  // native properties
  key: string
  adminIds: string[]
  caseTypeId: string
  formId: string
  theme: AppointmentTypeTheme
  // properties from nylas
  title: string
  description: string
  duration: number
  availability: IAppointmentAvailability
  location: string
  emailsDisabled?: boolean
}

export interface IAppointmentTypePatchBody {
  // native properties
  adminIds?: string[]
  status?: AppointmentTypeStatus
  theme?: AppointmentTypeTheme
  // properties from nylas
  title?: string
  description?: string
  duration?: number
  availability?: IAppointmentAvailability
  location?: string
  emailsDisabled?: boolean
}
